import { AxiosHeaders, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { HttpServiceConfigurator } from '../../../../../submodules/web-shared/services/http-service/http-service-configurator';

export class PublicHttpServiceConfigurator extends HttpServiceConfigurator {
  async prepareRequestConfig(
    baseConfig: InternalAxiosRequestConfig
  ): Promise<InternalAxiosRequestConfig> {
    const isFormData = baseConfig.data instanceof FormData;

    const headers = new AxiosHeaders(baseConfig.headers);
    headers.set('Client-Device', 'web');
    headers.set('Content-Type', isFormData ? 'multipart/form-data' : 'application/json');

    return {
      ...baseConfig,
      ...super.getHttpClientConfig(),
      headers,
    };
  }

  prepareHttpSuccessResponse(response: AxiosResponse) {
    return response;
  }
}